<template>
  <div class="divJava">
    <!-- <nav-bar></nav-bar> -->
    <DetailsNav></DetailsNav>
    <head-first-widge
      :subject="baseData.subject.name"
      :name="baseData.name"
      :date="baseData.lastUpdate"
      :desc="baseData.description"
      :logo="industryLogo"
      :logoDesc="industry"
      :numItems="numItems"
      :video="baseData.pVideoUrl"
      :nameImg="nameImg"
      :linkData="linkData"
    ></head-first-widge>
    <user-display-widge
      :displayData="displayData"
      :linkData="linkData"
      hoverColor="lightBlue"
      btnInitColor="#03C0FE"
      btnHoverColor="#03A8DE"
      :lastUpdate="baseData.lastUpdate"
    ></user-display-widge>
    <flow-widget
      :flowData="flowData"
      :baseHeight="baseHeight"
      :localItemIndex="localItemIndex"
      hoverColor="lightBlue"
      class="web_scroll"
    ></flow-widget>
    <div class="divOffsetParent">
      <project-advantage-widge
        :img="projectAdvantageImg"
        :desc="projectAdvantageDesc"
        pBg="linear-gradient(to right, #71DCFF, white)"
      >
        <title-widge
          :title="projectAdvantageTitle"
          :subTitle="projectAdvantageSubTitle"
        ></title-widge>
      </project-advantage-widge>
      <target-learner-widge :details="targetDetails">
        <title-widge
          :title="targetTitle"
          :subTitle="targetSubTitle"
        ></title-widge>
      </target-learner-widge>
      <frame-work-widge
        :data="functionFrameWorkWidgeData"
        style="padding-bottom: 0"
      >
        <title-widge
          :title="functionTitle"
          :subTitle="functionSubTitle"
        ></title-widge>
      </frame-work-widge>
      <frame-work-widge :data="technologyFrameWorkWidgeData">
        <title-widge
          :title="technologyTitle"
          :subTitle="technologySubTitle"
        ></title-widge>
      </frame-work-widge>
      <solve-plan-widge :bg="solvePlanBg">
        <title-widge
          :title="solvePlanTitle"
          :subTitle="solvePlanSubTitle"
          titleColor="rgb(255, 255, 255)"
          subTitleColor="rgb(255, 255, 255)"
          class="solvePlanTitle"
        ></title-widge>
      </solve-plan-widge>
      <study-path-widge
        :title="courseTitle"
        :subTitle="courseSubTitle"
        :data="courseDatas"
      ></study-path-widge>
      <techer-display-widge :data="teacherData"></techer-display-widge>
    </div>
    <bottom-widge></bottom-widge>
  </div>
</template>

<script>
import { Content } from "../../../../gqlapi/ContentDetail.js";
import { pushArr, courseDataToArr } from "./../../../js/tools";
// import navBar from "./../../../components/navBar";
import DetailsNav from "./../../../components/detailsNav.vue";
import bottomWidge from "./../../../components/bottomWidge";
import headFirstWidge from "./components/headFirstWidge3";
import UserDisplayWidge from "./../common/components/userDisplayWidge";
import projectAdvantageWidge from "./../common/components/projectAdvantageWidge";
import targetLearnerWidge from "./../common/components/targetLearnerWidge";
import frameWorkWidge from "./../common/components/frameWorkWidge";
import solvePlanWidge from "./../common/components/solvePlanWidge";
import studyPathWidge from "./components/studyPathWidge";
import techerDisplayWidge from "./components/techerDisplayWidge";
import flowWidget from "./../common/components/flowWidget";
import titleWidge from "./components/titleWidge";
export default {
  components: {
    // navBar,
    DetailsNav,
    bottomWidge,
    headFirstWidge,
    UserDisplayWidge,
    projectAdvantageWidge,
    targetLearnerWidge,
    frameWorkWidge,
    solvePlanWidge,
    studyPathWidge,
    techerDisplayWidge,
    flowWidget,
    titleWidge,
  },
  data() {
    return {
      baseData: {
        subject: {},
      },
      industryLogo: "",
      industry: "",
      numItems: [],
      nameImg: "",
      displayData: [],
      linkData: [],
      projectAdvantageTitle: "",
      projectAdvantageSubTitle: "",
      projectAdvantageImg: "",
      projectAdvantageDesc: [],
      targetTitle: "",
      targetSubTitle: "",
      targetDetails: [],
      functionFrameWorkWidgeData: {},
      functionTitle: "",
      functionSubTitle: "",
      technologyFrameWorkWidgeData: {},
      technologyTitle: "",
      technologySubTitle: "",
      solvePlanBg: "",
      solvePlanTitle: "",
      solvePlanSubTitle: "",
      courseTitle: "",
      courseSubTitle: "",
      courseDatas: [],
      teacherData: {},
      flowData: [],
      baseHeight: 0,
      localItemIndex: 0,
      oldHeight: 0,
      scrollClass: {
        pInit: "parent web_scroll",
        pChange: "parent web_scroll  p-change",
        cInit: "ul-init",
        cChange: "",
      },
      scrollFlag: {
        top: true,
        bottom: true,
      },
    };
  },

  created() {
    this.getData();
    window.addEventListener("scroll", this.handleScroll);
  },
  mounted() {
    Object.freeze(this.scrollFlag);
    Object.freeze(this.scrollClass);
    Object.freeze(this.oldHeight);

    // 埋点
    this.$trackEvent("详情页面", "mounted", this.baseData.name);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let oldHeight = this.oldHeight;
      let localHeight =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      let scrollHeight = this.baseHeight;
      let eles = document.querySelector(".divOffsetParent").children;
      for (let index in eles) {
        if (localHeight > eles[index].offsetTop + scrollHeight - 10) {
          this.localItemIndex = Number(index);
        }
      }
      let scrollFlag = this.scrollFlag;
      let scrollClass = this.scrollClass;
      if (oldHeight > localHeight) {
        //向上
        if (scrollFlag.top && localHeight < scrollHeight) {
          scrollFlag.top = false;
          scrollFlag.bottom = true;
          let parent = document.querySelector(".web_scroll");
          let child = parent.children[0];
          parent.className = scrollClass.pInit;
          child.className = scrollClass.cInit;
        }
      } else {
        //向下
        if (scrollFlag.bottom && localHeight > scrollHeight) {
          scrollFlag.top = true;
          scrollFlag.bottom = false;
          let parent = document.querySelector(".web_scroll");
          let child = parent.children[0];
          parent.className = scrollClass.pChange;
          child.className = scrollClass.cChange;
        }
      }
      this.oldHeight = localHeight;
    },
    getData() {
      this.$axios.post('/api',{
            operationName: "Content",
            variables:{
              id: sessionStorage.getItem("detailsId"),
            },
            query: Content
        })
        .then((res) => {
          this.baseData = res.data.data.pContent;
          this.getHeadFirstWidgeData();
          let detailsList = this.baseData.detailsList;
          if (detailsList.length !== 7) {
            return;
          }
          this.getDisplayData();
          this.getFlowData();
          this.getProjectAdvantageData();
          this.getTargetLearnerData();
          this.getFrameWorkWidgeData();
          this.getSolvePlanWidgeData();
          this.getCourseWidgeData();
          this.getTeacherWidgeData();
        });
    },
    getFlowData() {
      let detailsList = this.baseData.detailsList;
      let arr = [];
      detailsList.forEach((item, index) => {
        arr.push({
          index: index,
          desc: item.navTitle,
        });
      });
      this.flowData = arr;
    },
    getTeacherWidgeData() {
      let baseData = this.baseData;
      this.teacherData = baseData.detailsList[6];
    },
    getSolvePlanWidgeData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[4];
      this.solvePlanTitle = data.title;
      this.solvePlanSubTitle = data.subTitle;
      let tuWen = data.tuWen;
      if (tuWen && tuWen.image) {
        this.solvePlanBg = tuWen.image.url;
      }
    },
    getFrameWorkWidgeData() {
      let baseData = this.baseData;
      let functionFrameWorkWidgeData = baseData.detailsList[2];
      this.functionFrameWorkWidgeData = functionFrameWorkWidgeData;
      this.functionTitle = functionFrameWorkWidgeData.title;
      this.functionSubTitle = functionFrameWorkWidgeData.subTitle;
      let technologyFrameWorkWidgeData = baseData.detailsList[3];
      this.technologyFrameWorkWidgeData = technologyFrameWorkWidgeData;
      this.technologyTitle = technologyFrameWorkWidgeData.title;
      this.technologySubTitle = technologyFrameWorkWidgeData.subTitle;
    },
    getHeadFirstWidgeData() {
      let baseData = this.baseData;
      this.industryLogo = baseData.trade
        ? baseData.trade.iconFile
          ? baseData.trade.iconFile.url
          : ""
        : "";
      this.industry = baseData.trade ? baseData.trade.name : "";
      let numItems = [];
      pushArr(baseData.baseInfoTitle1, numItems);
      pushArr(baseData.baseInfoTitle2, numItems);
      pushArr(baseData.baseInfoTitle3, numItems);
      pushArr(baseData.baseInfoTitle4, numItems);
      pushArr(baseData.baseInfoTitle5, numItems);
      pushArr(baseData.baseInfoTitle6, numItems);
      this.numItems = numItems;
      this.nameImg = baseData.titleImage ? baseData.titleImage.url : "";
    },
    getDisplayData() {
      let data = this.baseData;
      let arr = [];
      for (let item of data.coverImageGroupList) {
        let imgs = [];
        item.imageAndLink.forEach((v) => {
          if (v.image) {
            imgs.push(v.image.url);
          }
        });
        arr.push({
          desc: item.groupName,
          type: item.imageType,
          imgs: imgs,
        });
      }
      this.displayData = arr;
      this.linkData = data.demoTitleLinkGroup;
    },
    getProjectAdvantageData() {
      let data = this.baseData.detailsList[0];
      this.projectAdvantageTitle = data.title;
      this.projectAdvantageSubTitle = data.subTitle;
      this.projectAdvantageSubTitle = data.subTitle;
      let tuWen = data.tuWen;
      if (!tuWen) {
        return;
      }
      let description = tuWen.description;
      if (!description) {
        return;
      }
      this.projectAdvantageDesc = description
        .split("。")
        .filter((item) => item && item.trim());
      this.projectAdvantageImg = tuWen.image
        ? tuWen.image.url
        : tuWen.bgImage
        ? tuWen.bgImage.url
        : "";
      this.projectAdvantageBg = tuWen.textBgImage ? tuWen.textBgImage.url : "";
    },
    getTargetLearnerData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[1];
      if (!data) {
        return;
      }
      this.targetTitle = data.title;
      this.targetSubTitle = data.subTitle;
      this.targetDetails = data.lieBiao;
    },
    getCourseWidgeData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[5];
      if (!data) {
        return;
      }
      this.courseTitle = data.title;
      this.courseSubTitle = data.subTitle;
      let arr = [];
      courseDataToArr(
        baseData.courseOutlineTitle1,
        baseData.courseOutlineDesc1,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle2,
        baseData.courseOutlineDesc2,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle3,
        baseData.courseOutlineDesc3,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle4,
        baseData.courseOutlineDesc4,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle5,
        baseData.courseOutlineDesc5,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle6,
        baseData.courseOutlineDesc6,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle7,
        baseData.courseOutlineDesc7,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle8,
        baseData.courseOutlineDesc8,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle9,
        baseData.courseOutlineDesc9,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle10,
        baseData.courseOutlineDesc10,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle11,
        baseData.courseOutlineDesc11,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle12,
        baseData.courseOutlineDesc12,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle13,
        baseData.courseOutlineDesc13,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle14,
        baseData.courseOutlineDesc14,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle15,
        baseData.courseOutlineDesc15,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle16,
        baseData.courseOutlineDesc16,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle17,
        baseData.courseOutlineDesc17,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle18,
        baseData.courseOutlineDesc18,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle19,
        baseData.courseOutlineDesc19,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle20,
        baseData.courseOutlineDesc20,
        arr
      );
      this.courseDatas = arr;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./scss/index.scss";
</style>
<style lang="scss" scoped>
.divJava {
  .divUserDisplay {
    ::v-deep .el-tabs__item.is-active {
      color: rgba(3, 192, 254, 1) !important;
      border-bottom: 5px solid rgba(3, 192, 254, 1) !important;
    }
  }
}
</style>
